import { useState, useCallback, useEffect } from "react"
import { Parallax } from "react-parallax"

const useImgOnError = (src: string, callBack: () =>void) : void => {

  useEffect(() => {

    let img = new Image()
    
    img.onerror = callBack
    img.src = src
  }, [src, callBack])

  }

export const ParallaxImage = ({src, alt} : {src: string, alt: string}) => {

    const [fallbackSrc, setFallbackSrc] = useState(src)
    useEffect(() => {
      setFallbackSrc(src)
    }, [src])
    const onError = useCallback( () => {
        setFallbackSrc('images/hi-gear-2.png')
    }, [setFallbackSrc])

    useImgOnError(src, onError)

    
    

    return <Parallax bgImage={fallbackSrc} strength={-50} >
        
    </Parallax>
}